import { Link } from "react-router-dom";
import { Clock, Instagram, MapPin, Phone } from "lucide-react";
import Logo from "./Logo";

const USEFUL_LINKS = [
    { label: "Hybrid", to: "/shop?category=hybrid" },
    { label: "Sativa", to: "/shop?category=sativa" },
    { label: "Indica", to: "/shop?category=indica" },
    { label: "Exotics", to: "/shop?category=exotic" },
    { label: "Edibles", to: "/shop?category=edibles" },
    { label: "Buy Psilocybin Mushrooms Online", to: "/shop?category=psilocybin-mushroom" },
    { label: "Cartridges", to: "/shop?category=cartridges" },
    { label: "Prerolls", to: "/shop?category=prerolls" },
    { label: "Merchandise", to: "/shop?category=merchandise" },
    { label: "Concentrates", to: "/shop?category=concentrates" },
];

export default function Footer() {
    return (
        <footer className="bg-[#071009] border-t border-leaf/15" data-testid="site-footer">
            <div className="container-x pt-16 md:pt-24 pb-10">
                <div className="grid md:grid-cols-12 gap-10 md:gap-8">
                    <div className="md:col-span-4">
                        <Logo className="h-14" alt="District Greenz DMV" />
                        <p className="mt-5 max-w-sm text-sage text-sm leading-relaxed">
                            A Washington DC dispensary and art gallery. Premium flower, edibles, vapes and concentrates —
                            free cannabis gifts with every art purchase.
                        </p>
                        <a
                            href="https://www.instagram.com/majestic_greenz"
                            target="_blank"
                            rel="noreferrer noopener"
                            data-testid="footer-instagram-link"
                            className="mt-6 inline-flex items-center gap-2.5 rounded-full border border-leaf/25 px-5 py-2.5 text-sm font-semibold text-bone hover:border-leaf hover:text-leaf-bright transition-colors"
                        >
                            <Instagram size={16} className="text-leaf-bright" />
                            @majestic_greenz
                        </a>
                        <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-gold/40 px-4 py-2 font-mono text-xs tracking-widest text-gold uppercase">
                            21+ only · Valid ID required
                        </div>
                    </div>

                    <div className="md:col-span-5">
                        <h4 className="eyebrow text-leaf-bright mb-5">Useful Links</h4>
                        <ul className="grid grid-cols-2 gap-x-6 gap-y-3 text-sm text-bone/85">
                            {USEFUL_LINKS.map((l) => (
                                <li key={l.label}>
                                    <Link to={l.to} data-testid={`footer-link-${l.to.split("=")[1]}`} className="hover:text-leaf-bright transition-colors">
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <h4 className="eyebrow text-leaf-bright mb-5">Visit</h4>
                        <ul className="space-y-4 text-sm text-bone/85">
                            <li className="flex gap-3">
                                <MapPin size={16} className="text-leaf mt-0.5 shrink-0" />
                                <span>
                                    Washington, DC — 20007, 20011 & 20009
                                    <br />
                                    <span className="text-sage text-xs">Pickup: 10 Florida Ave NW, DC 20001</span>
                                </span>
                            </li>
                            <li className="flex gap-3">
                                <Phone size={16} className="text-leaf mt-0.5 shrink-0" />
                                <a href="tel:+12027134325" data-testid="footer-phone-link" className="hover:text-leaf-bright transition-colors">
                                    (202) 713-4325
                                </a>
                            </li>
                            <li className="flex gap-3">
                                <Clock size={16} className="text-leaf mt-0.5 shrink-0" />
                                <span>24 Hours · Monday–Sunday</span>
                            </li>
                        </ul>
                        <h4 className="eyebrow text-leaf-bright mb-5 mt-8">Info</h4>
                        <ul className="space-y-3 text-sm text-bone/85">
                            <li><Link to="/blog" data-testid="footer-blog-link" className="hover:text-leaf-bright transition-colors">Blog</Link></li>
                            <li><Link to="/deals" data-testid="footer-deals-link" className="hover:text-leaf-bright transition-colors">Deals</Link></li>
                            <li><Link to="/shop" data-testid="footer-shop-link" className="hover:text-leaf-bright transition-colors">Shop All</Link></li>
                            <li><Link to="/cart" data-testid="footer-cart-link" className="hover:text-leaf-bright transition-colors">Cart</Link></li>
                            <li><a href="https://maps.google.com/?q=10+Florida+Ave+NW+Washington+DC+20001" target="_blank" rel="noreferrer" data-testid="footer-directions-link" className="hover:text-leaf-bright transition-colors">Get Directions</a></li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 md:mt-20 select-none overflow-hidden" aria-hidden="true">
                    <div className="font-display font-extrabold text-outline-bone leading-none text-[10vw] whitespace-nowrap tracking-tight">
                        DISTRICT GREENZ
                    </div>
                </div>

                <div className="mt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-leaf/10 pt-6 text-xs text-sage">
                    <span data-testid="footer-copyright">© {new Date().getFullYear()} District Greenz DMV · Washington, DC</span>
                    <span className="max-w-xl leading-relaxed">
                        Cannabis products are for adults 21 and over. Keep out of reach of children. Consumption while
                        pregnant or breastfeeding may be harmful.
                    </span>
                </div>
            </div>
        </footer>
    );
}
